import React, { useMemo } from "react"
import FadeInUp from "../animate/FadeInUp"
import "./style.css"
import Img from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"
import useLang from "../../hooks/useLang" 

const Clients = ({ title }) => {
  const lang = useLang()
  const isRtl = lang === "ar"

  const data = useStaticQuery(graphql`
    query ClientsQuery {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/content/clients//" } }
        limit: 200
      ) {
        edges {
          node {
            frontmatter {
              title
              image {
                publicURL
                childImageSharp {
                  fixed(height: 140) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const clients = useMemo(() => {
    return data.allMarkdownRemark.edges
      .map(({ node }) => node.frontmatter)
      .filter(
        c =>
          c?.title &&
          (c?.image?.childImageSharp?.fixed ||
            c?.image?.publicURL ||
            c?.image)
      )
  }, [data])

  if (clients.length === 0) return null

  const loopClients = [...clients, ...clients, ...clients, ...clients]

  const CARD_WIDTH = 140
  const CARD_GAP   = 30
  const SPEED      = 28

  const singleSetWidth = clients.length * (CARD_WIDTH + CARD_GAP)
  const duration = singleSetWidth / SPEED

  const renderCard = (client, idx) => {
    const hasSharp  = !!client?.image?.childImageSharp?.fixed
    const hasPublic = !!client?.image?.publicURL
    const isString  = typeof client?.image === "string"

    return (
      <div key={`client-${idx}`} className="client-logo-card">
        {hasSharp ? (
          <Img fixed={client.image.childImageSharp.fixed} alt={client.title} />
        ) : hasPublic ? (
          <img src={client.image.publicURL} alt={client.title} loading="lazy" />
        ) : isString ? (
          <img src={client.image} alt={client.title} loading="lazy" />
        ) : null}
      </div>
    )
  }

  return (
    <div className="clients-section">
      <div className="clients-container">
        <FadeInUp>
          <h2 className="clients-heading">{title}</h2>
        </FadeInUp>
        <FadeInUp>
          <div className="clients-accent-line" />
        </FadeInUp>

        <div className="carousel-content">
          <div
            className={`clients-track${isRtl ? " clients-track--rtl" : ""}`}
            style={{
              "--single-set-width": `${singleSetWidth}px`,
              "--duration": `${duration}s`,
            }}
          >
            {loopClients.map((client, idx) => renderCard(client, idx))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Clients
